import React, { useEffect, useState } from 'react';
import Reaptcha from 'reaptcha';
import api, { apiRaw } from '~/services/api';
import { useForm, Controller } from "react-hook-form";
import InputMask from "react-input-mask";
import ReactTooltip from "react-tooltip";
import {
    ButtonPadraoPrimary,
    Form,
    Input,
    GroupInLine,
    ContainerLine,
    Span,
    SpanErrorForm,
    Button,
    InputCheck,
    Select,
    TextArea
} from '~/styles/CommonStyles';
import Toastify from "~/components/Toastify";

import { Container, ContainerForm } from './stylesCadastro';
import { useRecoilState } from 'recoil';
import { conformidadeLGPD } from '~/atoms/conformidade';
import getUrlParameter from '~/helpers/getURLencode';

function Cadastro ( { location } ) {
    const params = new URLSearchParams( location.search );
    const _CHAVE = params.get( 'chave' );

    const [ ficha, setFicha ] = useState( {
        Nome: "",
        Nascimento: "",
        Sexo: "",
        Email: "",
        Telefone1: "",
        Telefone2: "",
        Celular: "",
        Endereco: "",
        Bairro: "",
        Cidade: "",
        Estado: "",
        CEP: "",
        CPF: "",
        RG: "",
        Profissao: "",
        Indicacao: "",
        Motivo: "",
        Medicamentos: "",
        HPP: "",
        HistoricoFamiliar: "",
        Obs: ""
    } );

    const [ recaptchaToken, setRecaptchaToken ] = useState( null );
    const { handleSubmit, register, errors, control, watch, getValues, triggerValidation, setValue } = useForm();
    const [ conformidade, setConformidade ] = useRecoilState( conformidadeLGPD );

    useEffect( () => {
        chamaSalvar();
    }, [ conformidade ] );

    async function chamaSalvar () {
        if ( conformidade.confirmado ) {
            setConformidade( { ...conformidade, confirmado: false } );
            let trig = await triggerValidation();

            if ( trig )
                onSubmit( getValues() );
        }
    }

    const onSubmit = async ( values ) => {
        let Exclui_mkt = conformidade.dadosMarketing ? 1 : 0;
        let CPFCGC = values.CPFCGC ? values.CPFCGC.replace( /[^0-9\.]+/g, '' ) : '';
        values.CEP = values.CEP ? values.CEP.replace( /[^0-9\.]+/g, '' ) : '';
        try {
            if ( !_CHAVE )
                return Toastify.error( 'Erro, falta de chave. Por favor abra o link enviado pelo médico.' );
            if ( !recaptchaToken )
                return Toastify.warning( 'Por favor, faça a verificação.' );

            let { data } = await api.post( `/apoio/atualizaPaciente`, { ...values, CPFCGC, Exclui_mkt, Chave: _CHAVE, responsecaptcha: recaptchaToken, dadosMarketing: conformidade.dadosMarketing, dadosSMS: conformidade.dadosMarketing } );

            if ( data == 'Success' ) {
                return Toastify.success( 'Avaliação enviada por sucesso.' );
            } else {
                return Toastify.warning( 'Não foi possivel salvar sua avaliação.' );
            }

        } catch ( error ) {
            console.log( error );
            return Promise.reject( error );;
        }
    };

    async function getCEP ( cep = '' ) {
        cep = cep.replace( /[^0-9\.]+/g, '' );
        if ( cep.length >= 8 ) {
            let { data } = await apiRaw.get( `https://api.pagar.me/1/zipcodes/${ cep }` );
            if ( data ) {
                setValue( 'Endereco', data.street );
                setValue( 'Bairro', data.neighborhood );
                setValue( 'Cidade', data.city );
                setValue( 'Estado', data.state );
            }
        }
    }

    return (
        <Container>
            <ContainerForm>
                <h1 style={ { textAlign: 'center' } }>Ficha Cadastral</h1>
                <Form onSubmit={ handleSubmit( onSubmit ) } id="FormPacinte" style={ { maxWidth: '1200px' } }>
                    <GroupInLine>
                        <ContainerLine>
                            <Span>CPF</Span>
                            <Controller
                                name="CPFCGC"
                                defaultValue={ ficha.CPFCGC }
                                as={
                                    <InputMask>
                                        { ( inputProps ) => <Input { ...inputProps } /> }
                                    </InputMask>
                                }
                                control={ control }
                                rules={ {
                                    required: "Obrigatório",
                                    pattern: {
                                        value: /^\d{3}\.\d{3}\.\d{3}\-\d{2}$/i, message: "CPF invalido, exemplo: 111.111.111-11"
                                    }
                                } }
                                mask="999.999.999-99"
                                invalido={ errors.CPFCGC }
                            />
                            { errors.CPFCGC && <SpanErrorForm>{ errors.CPFCGC.message }</SpanErrorForm> }
                        </ContainerLine>

                    </GroupInLine>
                    <GroupInLine>
                        <ContainerLine>
                            <Span>Telefone</Span>
                            <Input name="Telefone" defaultValue={ ficha.Telefone }
                                ref={ register } invalido={ errors.Telefone }
                            />
                            { errors.Telefone && <SpanErrorForm>{ errors.Telefone.message }</SpanErrorForm> }
                        </ContainerLine>
                        <ContainerLine>
                            <Span>2º Telefone</Span>
                            <Input name="Telefone1" defaultValue={ ficha.Telefone1 }
                                ref={ register } invalido={ errors.Telefone1 }
                            />
                            { errors.Telefone1 && <SpanErrorForm>{ errors.Telefone1.message }</SpanErrorForm> }
                        </ContainerLine>
                        <ContainerLine>
                            <Span>Celular</Span>
                            <Input name="Celular" defaultValue={ ficha.Celular }
                                ref={ register } invalido={ errors.Celular }
                            />
                            { errors.Celular && <SpanErrorForm>{ errors.Celular.message }</SpanErrorForm> }
                        </ContainerLine>
                    </GroupInLine>
                    <GroupInLine>
                        <ContainerLine>
                            <Span>CEP</Span>
                            <InputMask mask="99999-999" onChange={ ( e ) => getCEP( e.target.value ) }>
                                { ( inputProps ) => <Input name="CEP" invalido={ errors.CEP } defaultValue={ ficha.CEP } { ...inputProps } ref={ register } /> }
                            </InputMask>
                            { errors.CEP && <SpanErrorForm>{ errors.CEP.message }</SpanErrorForm> }
                        </ContainerLine>
                        <ContainerLine>
                            <Span>Cidade</Span>
                            <Input name="Cidade" defaultValue={ ficha.Cidade }
                                ref={ register } invalido={ errors.Cidade }
                            />
                            { errors.Cidade && <SpanErrorForm>{ errors.Cidade.message }</SpanErrorForm> }
                        </ContainerLine>
                        <ContainerLine>
                            <Span>Estado</Span>
                            <Select name="Estado" defaultValue={ ficha.Estado } ref={ register } invalido={ errors.Estado }>
                                { UFs.map( uf => <option key={ uf.sigla } value={ uf.sigla }>{ uf.nome }</option> ) }
                            </Select>
                            { errors.Estado && <SpanErrorForm>{ errors.Estado.message }</SpanErrorForm> }
                        </ContainerLine>

                    </GroupInLine>
                    <GroupInLine>
                        <ContainerLine>
                            <Span>Endereco</Span>
                            <Input name="Endereco" defaultValue={ ficha.Endereco }
                                ref={ register } invalido={ errors.Endereco }
                            />
                            { errors.Endereco && <SpanErrorForm>{ errors.Endereco.message }</SpanErrorForm> }
                        </ContainerLine>
                        <ContainerLine>
                            <Span>Bairro</Span>
                            <Input name="Bairro" defaultValue={ ficha.Bairro }
                                ref={ register } invalido={ errors.Bairro }
                                maxlength="25"
                            />
                            { errors.Bairro && <SpanErrorForm>{ errors.Bairro.message }</SpanErrorForm> }
                        </ContainerLine>
                    </GroupInLine>

                    <GroupInLine>
                        <ContainerLine>
                            <Span>Profissao</Span>
                            <Input name="Profissao" defaultValue={ ficha.Profissao }
                                ref={ register } invalido={ errors.Profissao }
                            />
                            { errors.Profissao && <SpanErrorForm>{ errors.Profissao.message }</SpanErrorForm> }
                        </ContainerLine>
                        <ContainerLine>
                            <Span>Referencias</Span>
                            <Input name="Referencias" defaultValue={ ficha.Referencias }
                                ref={ register } invalido={ errors.Referencias }
                            />
                            { errors.Referencias && <SpanErrorForm>{ errors.Referencias.message }</SpanErrorForm> }
                        </ContainerLine>
                    </GroupInLine>
                    <GroupInLine>
                        <ContainerLine>
                            <Span>Motivo da Consulta</Span>
                            <TextArea name="Motivo" defaultValue={ ficha.Motivo }
                                ref={ register } invalido={ errors.Motivo }
                            ></TextArea>
                            { errors.Motivo && <SpanErrorForm>{ errors.Motivo.message }</SpanErrorForm> }
                        </ContainerLine>
                    </GroupInLine>
                    <GroupInLine>
                        <ContainerLine>
                            <Span>Medicamentos em uso</Span>
                            <TextArea name="Medicamentos" defaultValue={ ficha.Medicamentos }
                                ref={ register } invalido={ errors.Medicamentos }
                            ></TextArea>
                            { errors.Medicamentos && <SpanErrorForm>{ errors.Medicamentos.message }</SpanErrorForm> }
                        </ContainerLine>
                    </GroupInLine>
                    <GroupInLine>
                        <ContainerLine>
                            <Span>Doenças pré-existentes e cirurgias realizadas</Span>
                            <TextArea name="HPP" defaultValue={ ficha.HPP }
                                ref={ register } invalido={ errors.HPP }
                            ></TextArea>
                            { errors.HPP && <SpanErrorForm>{ errors.HPP.message }</SpanErrorForm> }
                        </ContainerLine>
                    </GroupInLine>
                    <GroupInLine>
                        <ContainerLine>
                            <Span>Histórico Familiar</Span>
                            <TextArea name="HistoricoFamiliar" defaultValue={ ficha.ProfiHistoricoFamiliarssao }
                                ref={ register } invalido={ errors.HistoricoFamiliar }
                            ></TextArea>
                            { errors.HistoricoFamiliar && <SpanErrorForm>{ errors.HistoricoFamiliar.message }</SpanErrorForm> }
                        </ContainerLine>
                    </GroupInLine>
                    <GroupInLine>
                        <ContainerLine>
                            <Span>Observações</Span>
                            <TextArea name="Obs" defaultValue={ ficha.Obs }
                                ref={ register } invalido={ errors.Obs }
                            ></TextArea>
                            { errors.Obs && <SpanErrorForm>{ errors.Obs.message }</SpanErrorForm> }
                        </ContainerLine>
                    </GroupInLine>


                </Form>
                <div style={ { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', margin: '10px 0px' } }>
                    <Reaptcha
                        sitekey="6LfrDqgZAAAAABATEykmT5tqdYVnvx0B7Fm3Ahj3"
                        onVerify={ ( value ) => setRecaptchaToken( value ) }
                        onExpire={ () => setRecaptchaToken( null ) }
                    />
                    <a data-tip data-for='btnHome' >
                        <ButtonPadraoPrimary style={ { margin: '10px 0px' } } disabled={ !recaptchaToken } onClick={ () => setConformidade( { ...conformidade, popUpOpen: true } ) }>Salvar Dados</ButtonPadraoPrimary>
                    </a>
                    <ReactTooltip delayShow={ 300 } id='btnHome' place="bottom" type="dark" effect="solid">
                        { recaptchaToken ? <span>Salvar</span> : <span>Antes selecione o captcha de verificação (Não sou o robô)</span> }
                    </ReactTooltip>
                </div>
            </ContainerForm>
        </Container>
    );
}

export default Cadastro;


const UFs = [
    { "nome": "Acre", "sigla": "AC" },
    { "nome": "Alagoas", "sigla": "AL" },
    { "nome": "Amapá", "sigla": "AP" },
    { "nome": "Amazonas", "sigla": "AM" },
    { "nome": "Bahia", "sigla": "BA" },
    { "nome": "Ceará", "sigla": "CE" },
    { "nome": "Distrito Federal", "sigla": "DF" },
    { "nome": "Espírito Santo", "sigla": "ES" },
    { "nome": "Goiás", "sigla": "GO" },
    { "nome": "Maranhão", "sigla": "MA" },
    { "nome": "Mato Grosso", "sigla": "MT" },
    { "nome": "Mato Grosso do Sul", "sigla": "MS" },
    { "nome": "Minas Gerais", "sigla": "MG" },
    { "nome": "Pará", "sigla": "PA" },
    { "nome": "Paraíba", "sigla": "PB" },
    { "nome": "Paraná", "sigla": "PR" },
    { "nome": "Pernambuco", "sigla": "PE" },
    { "nome": "Piauí", "sigla": "PI" },
    { "nome": "Rio de Janeiro", "sigla": "RJ" },
    { "nome": "Rio Grande do Norte", "sigla": "RN" },
    { "nome": "Rio Grande do Sul", "sigla": "RS" },
    { "nome": "Rondônia", "sigla": "RO" },
    { "nome": "Roraima", "sigla": "RR" },
    { "nome": "Santa Catarina", "sigla": "SC" },
    { "nome": "São Paulo", "sigla": "SP" },
    { "nome": "Sergipe", "sigla": "SE" },
    { "nome": "Tocantins", "sigla": "TO" }
];

